import { useEffect, useRef } from 'react';

interface StarFieldProps {
  count?: number;
}

export function StarField({ count = 350 }: StarFieldProps) {
  const ref = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const draw = () => {
      const dpr = Math.max(1, window.devicePixelRatio || 1);
      const parent = canvas.parentElement as HTMLElement | null;
      if (!parent) return;
      const w = parent.clientWidth;
      const h = parent.clientHeight;
      canvas.width = Math.max(1, Math.floor(w * dpr));
      canvas.height = Math.max(1, Math.floor(h * dpr));
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (let i = 0; i < count; i++) {
        const x = Math.random() * canvas.width;
        const y = Math.random() * canvas.height;
        const r = (Math.random() * 1.2 + 0.3) * dpr;
        const alpha = Math.random() * 0.8 + 0.15;
        ctx.fillStyle = `rgba(255,255,255,${alpha.toFixed(2)})`;
        ctx.beginPath();
        ctx.arc(x, y, r, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
    };

    const ro = new ResizeObserver(() => draw());
    if (canvas.parentElement) ro.observe(canvas.parentElement);
    window.addEventListener('resize', draw);
    draw();
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', draw);
    };
  }, [count]);

  return <canvas ref={ref} aria-hidden className="absolute inset-0 z-0" style={{ animation: 'twinkle 12s ease-in-out infinite' }} />;
}
